import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="form"
// Handles form submission with debouncing support
export default class extends Controller {
  static values = {
    debounceDelay: { type: Number, default: 300 },
  };

  connect() {
    this.submitTimeout = null;
  }

  disconnect() {
    this.clearSubmitTimeout();
  }

  enableSubmit() {
    for (const button of this.element.querySelectorAll("[type=submit]")) {
      button.disabled = false;
    }
  }

  disableSubmit() {
    for (const button of this.element.querySelectorAll("[type=submit]")) {
      button.disabled = true;
    }
  }

  preventSubmit(event) {
    event.preventDefault();
  }

  pushState() {
    // Dispatch event to application controller to handle pushState
    const baseUrl = this.element.action || window.location.pathname;

    document.dispatchEvent(
      new CustomEvent("application:push-state", {
        detail: {
          form: this.element,
          baseUrl: baseUrl,
          delay: this.debounceDelayValue,
        },
      }),
    );
  }

  requestSubmit() {
    this.element.requestSubmit();
  }

  submit() {
    this.clearSubmitTimeout();
    this.submitTimeout = setTimeout(() => {
      this.element.requestSubmit();
    }, this.debounceDelayValue);
  }

  clearSubmitTimeout() {
    if (this.submitTimeout) {
      clearTimeout(this.submitTimeout);
      this.submitTimeout = null;
    }
  }
}
